import React, {Fragment} from "react";
import PropTypes from "prop-types";

import {getCurrencySign, getPriceWithCurrency, getRoomName, getTotalPrice, toFixedPrice} from "../../../misc/helpers";
import {getCurrentLayout} from "../../appLayout";
import PrintDocumentBodyCartItem from "./printDocumentBodyCartItem";
import PrintSimilarProducts from "./similarProducts/printSimilarProducts";
import {filterCartItems} from "../../look/lookNavigation/lookFunctions2";
import {getCommonVisualizerType, IS_LIXIL_UI} from "../../../config";
import {getShowPrice} from "../../../misc/priceFunctions";
import {
  getFeatureGroupFromWizardGroup,
  showWizardInsteadOfQT
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {WIZARD_GROUP_TYPES} from "../../../interfaces/wizardItemInterface";
import PrintDocumentBodyWizardItem from "./printDocumentBodyWizardItem";
import {getDifferentCurrencyCartItems} from "../../../misc/misc2";
import {
  getWizardGroupName,
  isSameVisualizerWizard
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import PrintDocumentDiscountsList from "./printDocumentDiscountsList";
import {TRANSLATES} from "../../../translatesProvider";

const PrintDocumentBody = (props) => {
  let {styles, quotes, cartItems, fabricatorData, locale, filterGroups, wizardState, sqftSlabState, messages,
    cartItemsThumbnails, hasMultipleWorkSheets, priceWorksheetState} = props;
  const fabricatorSettings = fabricatorData.settings;

  const {View, Text} = window.ReactPdfRenderer;

  if (IS_LIXIL_UI) {
    cartItems = filterCartItems(cartItems, true, true);
  }

  const getGroupName = (featureGroup, quoteIndex) => {
    const lowerCasedName = featureGroup.partName.toLowerCase();
    console.log("featureGroup.customNames", featureGroup.customNames);
    if (featureGroup.customNames && featureGroup.customNames[quoteIndex]) {
      return featureGroup.customNames[quoteIndex]
    }
    if (fabricatorData.isLowes || fabricatorData.isCaesarStone) {
      if (locale === "fr-FR" && messages["transDoc.customDisplayName_FR."+ lowerCasedName]) {
        return messages["transDoc.customDisplayName_FR."+ lowerCasedName]
      } else if (locale === "pl-PL" && messages["transDoc.customTranslateName_PL."+ lowerCasedName]) {
        return messages["transDoc.customTranslateName_PL."+ lowerCasedName]
      }
    }
    return featureGroup.customGroupDisplayName || featureGroup.partName
  };

  const showPrice = getShowPrice(fabricatorData, true);

  return quotes.map((quote, quoteIndex) => {

    const layout = getCurrentLayout(fabricatorSettings.allowVisualizerSwitching && quote.room ? quote.room : document.kvConfig.visualizerType);
    const visType = getCommonVisualizerType(fabricatorSettings.allowVisualizerSwitching && quote.room ? quote.room : document.kvConfig.visualizerType);

    const quoteTotalPrice = getTotalPrice(quoteIndex, false);
    // const subTotalPrice = getQuotePriceWithTaxes(quoteTotalPrice);
    const subTotalPrice = quoteTotalPrice.materialPrice;
    const fixedPrice = toFixedPrice(subTotalPrice);

    let uniqueCartItemIds = [];
    const quoteCartItems = cartItems.filter((cartItem) => cartItem.cartFeature && (cartItem.currentQuote === quoteIndex));

    const {wizardList, wizardIsActive, allWizardsValues} = wizardState;
    const showWizardSteps = showWizardInsteadOfQT(wizardList, wizardIsActive);

    const differentCurrencyObjects = getDifferentCurrencyCartItems(fabricatorSettings, quoteCartItems);
    const multiplier = quotes[quoteIndex].roomMultiplier || 1;
    const showMultiplier = multiplier > 1;

    return (
      <View style={styles.room} key={quoteIndex}>
        <Text style={styles.roomTitle}>
          {messages["receipt.content.roomTitle"]} {getRoomName(quoteIndex, cartItems, quotes, messages, locale, fabricatorData)}
        </Text>
        <View style={styles.roomBody}>
          {showWizardSteps ? wizardList.map(wizardItem => {
            const existingAllObject = allWizardsValues.find(wizSelObject => {
              return wizSelObject.wizardItemId === wizardItem.id && wizSelObject.quoteIndex === quoteIndex
                && isSameVisualizerWizard(wizSelObject, visType)
            });
            if (!existingAllObject || !existingAllObject.wizardSelectedValues) {
              return null
            }
            return Object.keys(existingAllObject.wizardSelectedValues).map(key => {
              const wizardGroup = existingAllObject.wizardSelectedValues[key].wizardGroup;
              if (wizardGroup && wizardGroup.nodeType === WIZARD_GROUP_TYPES.custom && !wizardGroup.hideInCartAndReceipt) {
                return <PrintDocumentBodyWizardItem styles={styles}
                                                    key={key}
                                                    fabricatorData={fabricatorData}
                                                    cartItemsThumbnails={cartItemsThumbnails}
                                                    messages={messages}
                                                    wizardGroup={wizardGroup}/>
              }
              let currentCartItems = cartItems.filter(cartItem => {
                if (cartItem.bundleParentId) {
                  return false
                }
                return cartItem.cartFeature && (cartItem.currentQuote === quoteIndex)
                  && (wizardGroup && cartItem.fromWizardGroupId
                    ? ((wizardGroup.id === cartItem.fromWizardGroupId)
                      || (wizardGroup.mergedGroups && wizardGroup.mergedGroups.some(wizG => wizG.id === cartItem.fromWizardGroupId)))
                    : +key === cartItem.fromWizardStep)
                  && !uniqueCartItemIds.includes(cartItem.id)
              });
              if (currentCartItems.length) {
                uniqueCartItemIds = [...uniqueCartItemIds, ...currentCartItems.map(cItem => cItem.id)];
                const slabsCartItems = currentCartItems.filter(cartItem => cartItem.partId === "slabs");
                const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup, layout);
                let featureGroupName = getWizardGroupName(wizardGroup, featureGroup, quoteIndex);
                if (!featureGroupName && featureGroup) {
                  featureGroupName = getGroupName(featureGroup, quoteIndex)
                }
                const mainCartItems = (
                  <View key={key} wrap={true}>
                    <Text style={styles.subPartTitle}>
                      {featureGroupName}
                      {featureGroup && (featureGroup.partId === "room") && showMultiplier ? ` (x${multiplier})` : ":"}
                    </Text>
                    {currentCartItems.map((cartItem, cartItemIndex) => {
                      if (cartItem.partId === "slabs") {
                        return null
                      }
                      return <PrintDocumentBodyCartItem key={cartItemIndex}
                                                        locale={locale}
                                                        fabricatorData={fabricatorData}
                                                        cartItem={cartItem}
                                                        cartItems={cartItems}
                                                        sqftSlabState={sqftSlabState}
                                                        cartItemsThumbnails={cartItemsThumbnails}
                                                        messages={messages}
                                                        styles={styles}/>
                    })}
                  </View>
                )
                return slabsCartItems.length ? (
                  <Fragment key={key + "slabs"}>
                    {mainCartItems}
                    <View wrap={true}>
                      <Text style={styles.subPartTitle}>
                        {messages["sqftFeaturesPopup.title.slabs"]}
                      </Text>
                      {slabsCartItems.map((cartItem, cartItemIndex) => {
                        return <PrintDocumentBodyCartItem key={cartItemIndex}
                                                          locale={locale}
                                                          fabricatorData={fabricatorData}
                                                          cartItem={cartItem}
                                                          cartItems={cartItems}
                                                          sqftSlabState={sqftSlabState}
                                                          cartItemsThumbnails={cartItemsThumbnails}
                                                          messages={messages}
                                                          styles={styles}/>
                      })}
                    </View>
                  </Fragment>
                ) : mainCartItems
              // } else if (wizardGroup && existingAllObject.wizardSelectedValues[key].selectedFeature && !wizardGroup.hideInCartAndReceipt) {
              //   return <PrintDocumentBodyWizardItem styles={styles}
              //                                       key={key}
              //                                       fabricatorData={fabricatorData}
              //                                       locale={locale}
              //                                       selectedFeature={existingAllObject.wizardSelectedValues[key].selectedFeature}
              //                                       wizardGroup={wizardGroup}/>
              }
            })
          }) : null}
          {layout.qtCategories && !showWizardSteps ? (
            layout.qtCategories.map(qtCategory => {
              return qtCategory.subParts.map((subPart, subPartIndex) => {
                let currentCartItems = quoteCartItems.filter(cartItem => {
                  if (cartItem.bundleParentId) {
                    return false
                  }
                  return (subPart.part.partId === cartItem.partId || (cartItem.relatedProductParent && subPart.part.partId === cartItem.relatedProductParent.partId))
                    && !uniqueCartItemIds.includes(cartItem.id)
                });
                if (!currentCartItems.length) {
                  return null
                }
                uniqueCartItemIds = [...uniqueCartItemIds, ...currentCartItems.map(cItem => cItem.id)];
                return (
                  <View key={subPartIndex} wrap={true}>
                    <Text style={styles.subPartTitle}>
                      {getGroupName(subPart.part, quoteIndex)}
                      {subPart.part && (subPart.part.partId === "room") && showMultiplier ? ` (x${multiplier})` : ":"}
                    </Text>
                    {currentCartItems.map((cartItem, cartItemIndex) => {
                      return <PrintDocumentBodyCartItem key={cartItemIndex}
                                                        locale={locale}
                                                        fabricatorData={fabricatorData}
                                                        cartItem={cartItem}
                                                        cartItems={cartItems}
                                                        sqftSlabState={sqftSlabState}
                                                        cartItemsThumbnails={cartItemsThumbnails}
                                                        messages={messages}
                                                        styles={styles}/>
                    })}
                  </View>
                )
              })
            })
          ) : null}
          {quoteCartItems.map((cartItem) => {
            if (!uniqueCartItemIds.includes(cartItem.id) && !cartItem.bundleParentId) {
              uniqueCartItemIds.push(cartItem.id);
              return (
                <View key={cartItem.id}>
                  <Text style={styles.subPartTitle}>
                    {cartItem.displayFakeFeatureGroupName
                      ? messages["sqftFeaturesPopup.title."  + cartItem.displayFakeFeatureGroupName]
                      : cartItem.cartFeature.dbFeature.customGroupName || cartItem.selectionGroup
                      || (cartItem.cartFeature && cartItem.cartFeature.getParent ? getGroupName(cartItem.cartFeature.getParent(), quoteIndex) : null)}
                  </Text>
                  <PrintDocumentBodyCartItem locale={locale}
                                             fabricatorData={fabricatorData}
                                             cartItem={cartItem}
                                             cartItems={cartItems}
                                             sqftSlabState={sqftSlabState}
                                             cartItemsThumbnails={cartItemsThumbnails}
                                             messages={messages}
                                             styles={styles}/>
                </View>
              )
            }
            return null
          })}
        </View>
        {showPrice ? (
          <Fragment>
            <View style={showMultiplier
              ? [styles.roomTotal, styles.flex, styles.flexRow, styles.flexBottom, styles.flexEnd]
              : styles.roomTotal}>
              <Text style={styles.roomTotalText}>
                {showMultiplier ? messages["shoppingCart.totalColumnsRoomTotal"] : messages["shoppingCart.totalColumnsSubTotal"]}:
              </Text>
              <Text style={styles.roomTotalAmount}>
                {getPriceWithCurrency(fabricatorSettings, toFixedPrice(subTotalPrice / multiplier))}
              </Text>
            </View>
            {showMultiplier ? (
              <View style={[styles.roomTotalSecond, styles.roomTotalMultiplier, styles.flex, styles.flexRow, styles.flexCenter, styles.flexEnd]}>
                <Text style={styles.roomTotalText}>
                  x{multiplier}:
                </Text>
                <Text style={styles.roomTotalAmount}>
                  {getPriceWithCurrency(fabricatorSettings, fixedPrice)}
                </Text>
              </View>
            ) : null}
            {differentCurrencyObjects.length ? differentCurrencyObjects.map(currObject => {
              const currentTotal = getTotalPrice(quoteIndex, false, currObject.cartItems);
              return (
                <View style={styles.roomTotalSecond} key={currObject.currency + quoteIndex}>
                  <Text style={styles.roomTotalText}>{messages["shoppingCart.totalColumnsSubTotal"]}:</Text>
                  <Text style={styles.roomTotalAmount}>
                    {getCurrencySign(currObject.currency, fabricatorSettings) + toFixedPrice(currentTotal.materialPrice, true)}
                  </Text>
                </View>
              )
            }) : null}
            <PrintSimilarProducts locale={locale}
                                  cartItems={cartItems}
                                  quoteIndex={quoteIndex}
                                  fabricatorData={fabricatorData}
                                  filterGroups={filterGroups}
                                  messages={messages}
                                  styles={styles}/>
          </Fragment>
        ) : null}
        {hasMultipleWorkSheets ? (
          <PrintDocumentDiscountsList priceWorksheetState={priceWorksheetState}
                                      quoteIndex={quoteIndex}
                                      hasMultipleWorkSheets={hasMultipleWorkSheets}
                                      fabricatorSettings={fabricatorSettings}
                                      messages={TRANSLATES}
                                      wizardState={wizardState}
                                      styles={styles}/>
        ) : null}
      </View>
    );
  })
};

PrintDocumentBody.propTypes = {
  quotes: PropTypes.array.isRequired,
  cartItems: PropTypes.array.isRequired,
  fabricatorData: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  filterGroups: PropTypes.array,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentBody
